import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * Component to prevent super admin from accessing user dashboard
 * Redirects super admin to admin dashboard if they somehow access /user-dashboard
 */
function UserDashboardRedirect() {
  const { user, isSuperAdmin } = useAuth();

  useEffect(() => {
    // Super admin should never access user dashboard
    if (isSuperAdmin() && user?.email === 'admin@mastersunion.org') {
      window.location.href = '/';
    }
  }, [user, isSuperAdmin]);

  return null;
}

export default UserDashboardRedirect;

